/**
 * Marble Fangs Size Advisor UI
 * Frozen engine via MfSizeAdvisorEngine.frozenRecommend
 * FINAL COPY LOCK (Jacob 2026-09-26). No analytics emits in V1.
 */
(function () {
  'use strict';

  var SIZE_ORDER = ['S', 'M', 'L', 'XL', 'XXL'];
  var SIZE_INDEX = { S: 0, M: 1, L: 2, XL: 3, XXL: 4 };

  var FIT_LABEL = { fitted: 'Fitted', regular: 'Regular', relaxed: 'Relaxed' };
  var BUILD_LABEL = { slim: 'Slim', average: 'Average', muscular: 'Muscular', broad: 'Broad' };
  var GARMENT_WORD = { tee: 'tee', hoodie: 'hoodie' };

  // Optional no-op analytics stub only — do not emit events in V1.
  if (typeof window.mfSizeAdvisorAnalytics !== 'function') {
    window.mfSizeAdvisorAnalytics = function () {};
  }

  function fitLabel(fit) {
    return FIT_LABEL[fit] || fit;
  }

  function buildLabel(build) {
    return BUILD_LABEL[build] || build;
  }

  function garmentWord(cat) {
    return GARMENT_WORD[cat] || cat;
  }

  function isLarger(a, b) {
    return (SIZE_INDEX[a] || 0) > (SIZE_INDEX[b] || 0);
  }

  function copyForOutcome(report, primary, alternate, fit, garment, stillCAfterPtp) {
    var FIT = fitLabel(fit);
    var GARMENT = garmentWord(garment);
    var out = { headline: '', bodyHtml: '', actions: [], footer: null, notice: null };

    if (report === 'A') {
      out.headline = 'Recommended size: ' + primary;
      out.bodyHtml =
        'For a ' +
        FIT +
        ' fit in this ' +
        GARMENT +
        ', ' +
        primary +
        ' is the closest match for your proportions and preference.';
      out.actions = [{ size: primary, role: 'primary', label: 'Choose ' + primary }];
      out.footer = { label: 'View size guide', href: '#size-guide' };
      return out;
    }

    if (report === 'B1' && alternate) {
      out.headline = 'Two sizes work';
      out.bodyHtml =
        'Both sizes suit your proportions and ' +
        FIT +
        ' preference. The difference is how you want the garment to sit.';
      var altLarger = isLarger(alternate, primary);
      var rows;
      if (altLarger) {
        rows = [
          {
            size: primary,
            role: 'primary',
            closer: true,
            text: 'Closer to your ' + FIT + ' preference — cleaner through the chest.'
          },
          {
            size: alternate,
            role: 'alternate',
            closer: false,
            text: 'Same length family, with more room through the chest and shoulders.'
          }
        ];
      } else {
        rows = [
          {
            size: primary,
            role: 'primary',
            closer: true,
            text: 'Closer to your ' + FIT + ' preference — the roomier of the two.'
          },
          {
            size: alternate,
            role: 'alternate',
            closer: false,
            text: 'A closer line through the chest, with less ease.'
          }
        ];
      }
      out.rows = rows;
      out.actions = [
        { size: primary, role: 'primary', label: 'Choose ' + primary },
        { size: alternate, role: 'alternate', label: 'Choose ' + alternate, ghost: true }
      ];
      out.footer = { label: 'Prefer a chart? View size guide.', href: '#size-guide' };
      return out;
    }

    if (report === 'B2') {
      out.headline = 'Recommended size: ' + primary;
      out.bodyHtml =
        primary +
        ' is the closer match for your proportions and ' +
        FIT +
        ' preference.';
      if (alternate) {
        var roomierOrCloser = isLarger(alternate, primary) ? 'roomier' : 'closer';
        out.soft =
          'For a slightly ' +
          roomierOrCloser +
          ' fit, ' +
          alternate +
          ' can also work.';
      }
      out.actions = [{ size: primary, role: 'primary', label: 'Choose ' + primary }];
      if (alternate) {
        out.actions.push({
          size: alternate,
          role: 'alternate',
          label: 'Choose ' + alternate,
          ghost: true
        });
      }
      out.footer = { label: 'View size guide', href: '#size-guide' };
      return out;
    }

    // C
    out.headline = 'No clear size match';
    if (stillCAfterPtp) {
      out.bodyHtml =
        'This measurement still doesn’t point clearly to one size. Compare the size guide for the best next step.';
    } else {
      out.bodyHtml =
        'Your proportions and fit preference don’t point clearly to one size.';
    }
    out.actions = [];
    out.footer = { label: 'View size guide', href: '#size-guide' };
    out.showRefine = !stillCAfterPtp;
    return out;
  }

  function qs(root, sel) {
    return root.querySelector(sel);
  }

  function qsa(root, sel) {
    return Array.prototype.slice.call(root.querySelectorAll(sel));
  }

  function parseAvailability(root) {
    var el = qs(root, '[data-size-advisor-availability]');
    if (!el) return { sizes: {}, variants: [] };
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return { sizes: {}, variants: [] };
    }
  }

  function sizeAvailable(availability, size) {
    if (!availability || !availability.sizes) return true;
    if (Object.prototype.hasOwnProperty.call(availability.sizes, size)) {
      return !!availability.sizes[size];
    }
    return true;
  }

  function findSizePill(size) {
    var inputs = document.querySelectorAll(
      '.mf-product-option--size input[type="radio"], .product-form__input--pill input[type="radio"]'
    );
    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      var fieldset = input.closest('fieldset');
      if (!fieldset) continue;
      var isSize =
        fieldset.classList.contains('mf-product-option--size') ||
        (fieldset.querySelector('.mf-product-option__size-advisor') != null) ||
        (fieldset.querySelector('.mf-product-option__size-guide') != null);
      if (!isSize) continue;
      if (String(input.value).toUpperCase() === String(size).toUpperCase()) {
        return input;
      }
    }
    // Fallback: any pill whose value matches size letter
    for (var j = 0; j < inputs.length; j++) {
      if (String(inputs[j].value).toUpperCase() === String(size).toUpperCase()) {
        return inputs[j];
      }
    }
    return null;
  }

  function clearPillHighlights() {
    qsa(document, 'label.mf-sa-rec-primary, label.mf-sa-rec-alternate').forEach(function (lab) {
      lab.classList.remove('mf-sa-rec-primary', 'mf-sa-rec-alternate');
      lab.removeAttribute('aria-description');
    });
  }

  function highlightPills(primary, alternate, report) {
    clearPillHighlights();
    function mark(size, cls, desc) {
      var input = findSizePill(size);
      if (!input) return;
      var lab = document.querySelector('label[for="' + input.id + '"]');
      if (!lab) lab = input.nextElementSibling;
      if (!lab) return;
      lab.classList.add(cls);
      lab.setAttribute('aria-description', desc);
    }
    if (primary && report !== 'C') {
      mark(primary, 'mf-sa-rec-primary', 'Recommended by Size Advisor');
    }
    if (alternate && report === 'B1') {
      mark(alternate, 'mf-sa-rec-alternate', 'Also works per Size Advisor');
    }
  }

  function selectSizePill(size) {
    var input = findSizePill(size);
    if (!input) return false;
    if (input.disabled || input.classList.contains('disabled')) return false;
    input.click();
    return true;
  }

  function isMobile() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  // Live query — variant-selects remount replaces [data-size-advisor-open] (Path B).
  function getOpenBtns() {
    return qsa(document, '[data-size-advisor-open]').filter(function (btn) {
      return !btn.closest('.quick-add-modal');
    });
  }

  function initRoot(root) {
    if (root.__mfSaInit) return;
    root.__mfSaInit = true;

    var category = root.getAttribute('data-size-advisor-category');
    if (!category) return;

    var availability = parseAvailability(root);
    var closeBtn = qs(root, '[data-size-advisor-close]');
    var backdrop = qs(root, '[data-size-advisor-backdrop]');
    var form = qs(root, '[data-size-advisor-form]');
    var formFields = qs(root, '[data-sa-form-fields]');
    var summaryEl = qs(root, '[data-sa-summary]');
    var summaryText = qs(root, '[data-sa-summary-text]');
    var editBtn = qs(root, '[data-sa-edit]');
    var resultsEl = qs(root, '[data-sa-results]');
    var errorEl = qs(root, '[data-sa-error]');
    var ptpWrap = qs(root, '[data-sa-ptp]');
    var ptpToggle = qs(root, '[data-sa-ptp-toggle]');
    var ptpPanel = qs(root, '[data-sa-ptp-panel]');
    var ptpInput = qs(root, '[data-sa-ptp-input]');
    var ptpUpdate = qs(root, '[data-sa-ptp-update]');
    var ptpDismiss = qs(root, '[data-sa-ptp-dismiss]');
    var heading = qs(root, '#size-advisor-heading');
    var sheet = qs(root, '[data-size-advisor-sheet]');

    // Session-only memory (no localStorage)
    var state = {
      open: false,
      lastResult: null,
      lastReport: null,
      appliedPtp: false,
      build: 'average',
      fit: 'regular',
      favoritePtp: null,
      editing: false
    };

    function setSegmentGroup(groupEl, value) {
      qsa(groupEl, '[role="radio"]').forEach(function (btn) {
        var on = btn.getAttribute('data-value') === value;
        btn.classList.toggle('is-selected', on);
        btn.setAttribute('aria-checked', on ? 'true' : 'false');
      });
    }

    function wireSegments(groupEl, key) {
      if (!groupEl) return;
      qsa(groupEl, '[role="radio"]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          state[key] = btn.getAttribute('data-value');
          setSegmentGroup(groupEl, state[key]);
        });
        btn.addEventListener('keydown', function (ev) {
          var radios = qsa(groupEl, '[role="radio"]');
          var idx = radios.indexOf(btn);
          var next = idx;
          if (ev.key === 'ArrowRight' || ev.key === 'ArrowDown') next = (idx + 1) % radios.length;
          else if (ev.key === 'ArrowLeft' || ev.key === 'ArrowUp')
            next = (idx - 1 + radios.length) % radios.length;
          else return;
          ev.preventDefault();
          radios[next].focus();
          radios[next].click();
        });
      });
    }

    wireSegments(qs(root, '[data-sa-build]'), 'build');
    wireSegments(qs(root, '[data-sa-fit]'), 'fit');

    function openPanel() {
      root.hidden = false;
      root.classList.add('is-open');
      state.open = true;
      getOpenBtns().forEach(function (b) {
        b.setAttribute('aria-expanded', 'true');
      });
      if (isMobile()) {
        root.setAttribute('role', 'dialog');
        root.setAttribute('aria-modal', 'true');
        root.setAttribute('aria-labelledby', 'size-advisor-heading');
        if (backdrop) backdrop.hidden = false;
        document.documentElement.style.overflow = 'hidden';
      } else {
        root.removeAttribute('aria-modal');
        root.setAttribute('role', 'region');
        root.setAttribute('aria-labelledby', 'size-advisor-heading');
        if (backdrop) backdrop.hidden = true;
      }
      if (heading) heading.focus();
      else {
        var ft = qs(root, '[data-sa-height-ft]');
        if (ft) ft.focus();
      }
    }

    function closePanel() {
      root.hidden = true;
      root.classList.remove('is-open');
      state.open = false;
      var btns = getOpenBtns();
      btns.forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
      });
      if (backdrop) backdrop.hidden = true;
      document.documentElement.style.overflow = '';
      root.removeAttribute('aria-modal');
      if (btns[0]) btns[0].focus();
    }

    // Expose for document-level delegation (Path B remounts replace open triggers).
    root.__mfSaToggle = function () {
      if (state.open) closePanel();
      else openPanel();
    };
    root.__mfSaClose = closePanel;

    if (closeBtn) closeBtn.addEventListener('click', closePanel);
    if (backdrop) backdrop.addEventListener('click', closePanel);

    // Mobile focus trap (lightweight)
    root.addEventListener('keydown', function (ev) {
      if (!state.open || !isMobile() || ev.key !== 'Tab') return;
      var focusables = qsa(
        root,
        'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
      ).filter(function (el) {
        return el.offsetParent !== null || el === document.activeElement;
      });
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (ev.shiftKey && document.activeElement === first) {
        ev.preventDefault();
        last.focus();
      } else if (!ev.shiftKey && document.activeElement === last) {
        ev.preventDefault();
        first.focus();
      }
    });

    function readInputs() {
      var ft = Number(qs(root, '[data-sa-height-ft]').value);
      var inch = Number(qs(root, '[data-sa-height-in]').value);
      var weight = Number(qs(root, '[data-sa-weight]').value);
      return {
        heightIn: ft * 12 + inch,
        heightFt: ft,
        heightInch: inch,
        weightLb: weight,
        build: state.build,
        preferredFit: state.fit
      };
    }

    function formatSummary(inputs) {
      var ft = inputs.heightFt;
      var inch = inputs.heightInch;
      var w = Math.round(inputs.weightLb);
      return (
        ft +
        '′' +
        inch +
        '″ · ' +
        w +
        ' lb · ' +
        buildLabel(inputs.build) +
        ' · ' +
        fitLabel(inputs.preferredFit)
      );
    }

    function enterCompactMode(inputs) {
      state.editing = false;
      root.classList.add('has-results');
      if (sheet) sheet.classList.add('has-results');
      if (formFields) formFields.hidden = true;
      if (summaryEl) {
        summaryEl.hidden = false;
        if (summaryText) summaryText.textContent = formatSummary(inputs);
      }
    }

    function enterEditMode() {
      state.editing = true;
      root.classList.remove('has-results');
      if (sheet) sheet.classList.remove('has-results');
      if (formFields) formFields.hidden = false;
      if (summaryEl) summaryEl.hidden = true;
      var ft = qs(root, '[data-sa-height-ft]');
      if (ft) ft.focus();
    }

    function collapsePtp() {
      if (ptpPanel) ptpPanel.hidden = true;
      if (ptpToggle) ptpToggle.setAttribute('aria-expanded', 'false');
    }

    function validate(inputs) {
      if (inputs.heightIn < 48 || inputs.heightIn > 95) {
        return 'Enter a height between 4′0″ and 7′11″.';
      }
      if (!(inputs.weightLb >= 90 && inputs.weightLb <= 350) || !Number.isFinite(inputs.weightLb)) {
        return 'Enter a weight between 90 and 350 lb.';
      }
      return null;
    }

    function chooseClass(role, ghost) {
      var cls = 'mf-size-advisor__choose';
      if (ghost || role === 'alternate') {
        cls += ' mf-size-advisor__choose--ghost';
      } else {
        cls += ' mf-size-advisor__choose--primary';
      }
      return cls;
    }

    function renderResults(result, opts) {
      opts = opts || {};
      var report = result.reportOutcomeP1;
      var primary = result.primary;
      var alternate = result.alternate;
      var copy = copyForOutcome(
        report,
        primary,
        alternate,
        state.fit,
        category,
        !!opts.stillCAfterPtp
      );

      state.lastResult = result;
      state.lastReport = report;

      var html = '';
      html += '<p class="mf-size-advisor__section-label">Your size recommendation</p>';
      html += '<h3 class="mf-size-advisor__headline">' + escapeHtml(copy.headline) + '</h3>';
      if (copy.bodyHtml) {
        html += '<p class="mf-size-advisor__body">' + escapeHtml(copy.bodyHtml) + '</p>';
      }
      if (copy.soft) {
        html += '<p class="mf-size-advisor__soft">' + escapeHtml(copy.soft) + '</p>';
      }

      if (copy.rows && copy.rows.length) {
        html += '<div class="mf-size-advisor__size-rows">';
        copy.rows.forEach(function (row) {
          var rowMod =
            row.role === 'primary'
              ? ' mf-size-advisor__size-row--primary'
              : ' mf-size-advisor__size-row--alternate';
          html += '<div class="mf-size-advisor__size-row' + rowMod + '">';
          html += '<div class="mf-size-advisor__size-row-head">';
          html += '<span>' + escapeHtml(row.size) + '</span>';
          if (row.closer) html += '<span class="mf-size-advisor__chip">Closer match</span>';
          html += '</div>';
          html += '<p>' + escapeHtml(row.text) + '</p>';
          var avail = sizeAvailable(availability, row.size);
          html +=
            '<button type="button" class="' +
            chooseClass(row.role, row.role === 'alternate') +
            '" data-sa-choose="' +
            escapeAttr(row.size) +
            '" data-sa-role="' +
            escapeAttr(row.role) +
            '"' +
            (avail ? '' : ' disabled') +
            '>Choose ' +
            escapeHtml(row.size) +
            '</button>';
          if (!avail) {
            html +=
              '<p class="mf-size-advisor__oos">' +
              escapeHtml(row.size + ' is currently unavailable in this color.') +
              '</p>';
          }
          html += '</div>';
        });
        html += '</div>';
      } else if (copy.actions && copy.actions.length) {
        html += '<div class="mf-size-advisor__actions">';
        copy.actions.forEach(function (act) {
          var avail = sizeAvailable(availability, act.size);
          html +=
            '<button type="button" class="' +
            chooseClass(act.role, !!act.ghost) +
            '" data-sa-choose="' +
            escapeAttr(act.size) +
            '" data-sa-role="' +
            escapeAttr(act.role) +
            '"' +
            (avail ? '' : ' disabled') +
            '>' +
            escapeHtml(act.label) +
            '</button>';
        });
        html += '</div>';
        copy.actions.forEach(function (act) {
          if (!sizeAvailable(availability, act.size)) {
            html +=
              '<p class="mf-size-advisor__oos">' +
              escapeHtml(act.size + ' is currently unavailable in this color.') +
              '</p>';
          }
        });
      }

      html += '<div class="mf-size-advisor__confirm" data-sa-confirm hidden></div>';

      if (copy.footer) {
        html +=
          '<a class="mf-size-advisor__footer-link" href="' +
          escapeAttr(copy.footer.href) +
          '">' +
          escapeHtml(copy.footer.label) +
          '</a>';
      }

      resultsEl.hidden = false;
      resultsEl.innerHTML = html;
      if (!resultsEl.hasAttribute('tabindex')) resultsEl.setAttribute('tabindex', '-1');
      try {
        resultsEl.focus({ preventScroll: true });
      } catch (e) {
        try {
          resultsEl.focus();
        } catch (e2) {}
      }

      highlightPills(primary, alternate, report);

      // Compact inputs → summary; always collapse PTP on fresh recommend
      enterCompactMode(readInputs());
      collapsePtp();

      if (ptpWrap) {
        ptpWrap.hidden = false;
      }
    }

    function escapeHtml(s) {
      return String(s)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }
    function escapeAttr(s) {
      return escapeHtml(s).replace(/'/g, '&#39;');
    }

    function runRecommend(favoritePtp) {
      if (!window.MfSizeAdvisorEngine || typeof window.MfSizeAdvisorEngine.frozenRecommend !== 'function') {
        if (errorEl) {
          errorEl.hidden = false;
          errorEl.textContent = 'Size Advisor is temporarily unavailable.';
        }
        return;
      }
      var inputs = readInputs();
      var err = validate(inputs);
      if (err) {
        if (errorEl) {
          errorEl.hidden = false;
          errorEl.textContent = err;
        }
        return;
      }
      if (errorEl) {
        errorEl.hidden = true;
        errorEl.textContent = '';
      }

      var payload = {
        garment: category,
        heightIn: inputs.heightIn,
        weightLb: inputs.weightLb,
        build: inputs.build,
        preferredFit: inputs.preferredFit
      };
      if (favoritePtp != null && favoritePtp > 0) {
        payload.favoritePtp = favoritePtp;
        payload.ptpGarmentType = category;
      }

      var result = window.MfSizeAdvisorEngine.frozenRecommend(payload);
      var stillC =
        !!state.appliedPtp && result.reportOutcomeP1 === 'C' && favoritePtp != null;
      if (favoritePtp != null) state.appliedPtp = true;
      renderResults(result, { stillCAfterPtp: stillC });
    }

    if (form) {
      form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        state.favoritePtp = null;
        state.appliedPtp = false;
        runRecommend(null);
      });
    }

    if (editBtn) {
      editBtn.addEventListener('click', function () {
        enterEditMode();
      });
    }

    resultsEl.addEventListener('click', function (ev) {
      var btn = ev.target.closest('[data-sa-choose]');
      if (!btn) return;
      var size = btn.getAttribute('data-sa-choose');
      if (!sizeAvailable(availability, size)) {
        var oos =
          size + ' is currently unavailable in this color.';
        var confirm = qs(resultsEl, '[data-sa-confirm]');
        if (confirm) {
          confirm.hidden = false;
          confirm.textContent = oos + ' Choose another size on the product, or switch color.';
        }
        return;
      }
      var ok = selectSizePill(size);
      var confirmEl = qs(resultsEl, '[data-sa-confirm]');
      if (confirmEl) {
        confirmEl.hidden = false;
        confirmEl.textContent = ok
          ? 'Size ' + size + ' selected.'
          : size + ' is currently unavailable in this color.';
      }
    });

    if (ptpToggle) {
      ptpToggle.addEventListener('click', function () {
        var open = ptpPanel && ptpPanel.hidden;
        if (ptpPanel) ptpPanel.hidden = !open;
        ptpToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open && ptpInput) ptpInput.focus();
      });
    }
    if (ptpDismiss) {
      ptpDismiss.addEventListener('click', function () {
        if (ptpPanel) ptpPanel.hidden = true;
        if (ptpToggle) ptpToggle.setAttribute('aria-expanded', 'false');
      });
    }
    if (ptpUpdate) {
      ptpUpdate.addEventListener('click', function () {
        var v = ptpInput ? Number(ptpInput.value) : NaN;
        if (!Number.isFinite(v) || v <= 0) {
          if (errorEl) {
            errorEl.hidden = false;
            errorEl.textContent = 'Enter a pit-to-pit measurement in inches.';
          }
          return;
        }
        state.favoritePtp = v;
        state.appliedPtp = true;
        runRecommend(v);
      });
    }
  }

  function boot() {
    qsa(document, '#size-advisor').forEach(initRoot);
  }

  // Document delegates once — survive Path B variant-selects remounts;
  // product-info:loaded re-boots for Path A full product-info swap.
  var docDelegatesBound = false;
  function bindDocDelegates() {
    if (docDelegatesBound) return;
    docDelegatesBound = true;

    document.addEventListener('click', function (ev) {
      var t = ev.target;
      if (!t || !t.closest) return;
      var btn = t.closest('[data-size-advisor-open]');
      if (!btn || btn.closest('.quick-add-modal')) return;
      var pi = btn.closest('product-info');
      var root = pi ? qs(pi, '#size-advisor') : qs(document, '#size-advisor');
      if (!root || typeof root.__mfSaToggle !== 'function') return;
      ev.preventDefault();
      root.__mfSaToggle();
    });

    document.addEventListener('keydown', function (ev) {
      if (ev.key !== 'Escape') return;
      var openRoot = qs(document, '#size-advisor.is-open');
      if (!openRoot || typeof openRoot.__mfSaClose !== 'function') return;
      ev.preventDefault();
      openRoot.__mfSaClose();
    });

    document.addEventListener('product-info:loaded', function () {
      boot();
    });
  }

  bindDocDelegates();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
